/**
 * The shortlist's batching (swipe-deck ticket 13, owner 2026-10-09: "load it in batches, progressive
 * load next sets when user swipes"). The deck is every Recommended job the account has not decided on;
 * the server hands it over `limit` cards at a time and the screen asks for the next batch while the
 * person is still swiping the last one. `flows.mjs` reads these two numbers from this file.
 */

/** Cards asked for per read: the first batch and every batch after it. The server's default `limit` is the same 10 (its maximum is 20). */
export const DECK_BATCH = 10;

/** The next batch is fetched when this many undecided cards or fewer are held: at 4, the person has swiped 6 of 10 and has the rest in hand before the 10th. */
export const DECK_PREFETCH_AT = 4;

/**
 * How long the held deck is trusted when the screen mounts again (a job page and Back, Action and
 * Back). Inside it the cards, the position and the counters are what the person left; past it the first
 * batch is read again, which is the same deck (decided cards are not in it) and never shows a card twice.
 */
export const DECK_STALE_MS = 5 * 60_000;
